import { getProductCatalogueApiConfig } from '../config/actions';
/**
 * @internal
 */
export var setApiKeyHeader = function (options) {
    var config = getProductCatalogueApiConfig();
    // Either create or convert to Headers.
    if (!options.headers) {
        options.headers = new Headers();
    }
    else {
        options.headers = new Headers(options.headers);
    }
    if (config.apiKey) {
        options.headers.set('api_key', config.apiKey);
    }
};
